import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { BaseForm } from "@app/data/shared/models/base-form.interface";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { KlDyModalComponent } from "@dashboard/components/partials/modal/modal.component";
import { KlAlertService } from "@app/modules/shared/services/message/alert.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { VatRateDto } from "@dashboard/modules/application-params/vat-rate/model/vat-rate.dto";

@Component({
  selector: "kl-new-vat-rate",
  templateUrl: "./vat-rate-form.component.html",
})
export class VatRateFormComponent implements OnInit, OnDestroy, BaseForm {
  @ViewChild("VatRateForm", { static: true }) private vatRateForm;
  @Input() entity: VatRateDto = new VatRateDto();
  @Input() isReadOnly: boolean;
  @Input() modalId: string;
  @Input() listTabId: string;
  @Input() mode: string;
  title = "";
  alertShow: boolean;
  alertType: string;
  alertMessage: any;
  saveForm = false;
  isOpenFirstAccordion = true;

  constructor(
    private apiService: ApiService,
    public klModal: KlDyModalComponent,
    private translateService: TranslateService,
    private alertService: KlAlertService,
    private klLoadingService: KlLoadingService,
    private explorerService: ExplorerService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    switch (this.mode) {
      case "add":
        this.entity.type = "Domestic";
        this.title =
          this.translateService.instant("new") +
          " " +
          this.translateService.instant("vat_rate");
        break;
      case "edit":
      case "view":
        this.title = this.translateService.instant("vat_rate") + " - ";
        break;
    }
    this.klLoadingService.hide();
  }

  clearForm() {
    Object.keys(this.entity).forEach((o) => {
      if (o !== "type") {
        delete this.entity[o];
      }
    });
  }

  commitSave(action: any) {
    if (this.vatRateForm.valid) {
      this.saveForm = true;
      this.isReadOnly = true;
      switch (action) {
        case "SAVE":
          switch (this.mode) {
            case "add":
              this.apiService.addData("vatgroup", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
            case "edit":
              this.apiService.updateData("vatgroup", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
          }
          break;
        case "SAVE_NEW":
          this.apiService.addData("vatgroup", this.entity).subscribe(
            (response) => this.handleNew(response),
            (error) => this.handleError(error)
          );
          break;
      }
    } else {
      this.handleError("required_fields_must_be_entered");
    }
  }

  handleResponse(response) {
    this.saveForm = false;
    this.toastService.toastSuccess();
    if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
  }

  handleNew(response) {
    this.alertShow = false;
    this.isReadOnly = false;
    this.saveForm = false;
    this.toastService.toastSuccess();
    this.clearForm();
  }

  handleError(error) {
    this.alertMessage = this.alertService.error(error);
    this.isReadOnly = false;
    this.saveForm = false;
  }

  lockEntity(id: number) {
    return this.apiService.lockData("vatgroup", id);
  }

  unlockEntity() {
    this.apiService.unlockData("vatgroup", this.entity.id).subscribe();
  }

  ngOnDestroy() {
    if (this.mode === "edit") {
      this.unlockEntity();
    }
  }
}
